
const digest = '8a3cbe32bc07cfc986de569afe01076feec1eb72b9fb01f3733f0193fe6fad47';
const classes = {"buttonsWrapper":"_buttonsWrapper_1v3op_1"};
const css = `._buttonsWrapper_1v3op_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  